import { render } from "./RuleWaitingListStatus.vue?vue&type=template&id=2f2220ba"
import script from "./RuleWaitingListStatus.vue?vue&type=script&lang=js"
export * from "./RuleWaitingListStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/RuleWaitingListStatus.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f2220ba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f2220ba', __exports__)) {
    api.reload('2f2220ba', __exports__)
  }
  
  module.hot.accept("./RuleWaitingListStatus.vue?vue&type=template&id=2f2220ba", () => {
    api.rerender('2f2220ba', render)
  })

}


export default __exports__